import { connect } from 'react-redux'
import * as action from '../../state/instance-detail/action'
import * as selector from '../../state/instance-detail/selector'
import CommentList from '../instance-detail/CommentList'

const mapStateToProps = (state, props) => {
    return {
        commentText: selector.selectCommentText(state),
        commentList: selector.selectCommentList(state),
    }
}

const mapDispatchToProps = {
    changeProcessComment: action.changeProcessComment,
    commentProcessInstance: action.commentProcessInstance,
}

export default connect(mapStateToProps, mapDispatchToProps)(CommentList)



// WEBPACK FOOTER //
// ./src/modules/process/component/task-widget/CommentListWidgetContainer.js